import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { validate, validateForm as formValidate } from 'utils/formvalidate';
import SurveyTemplateForm from "./SurveyTemplateForm";
import { ROUTES } from '../../constants/Routes';
import SurveyTemplateApi from '../../apis/SurveyTemplate';
import Toaster from '../Toaster';
import SurveyTemplateCategoryApi from '../../apis/surveys/SurveyTemplateCategory';

class AddSurveyTemplate extends Component {
  constructor() {
    super();
    this.state = {
      surveyName: {},
      surveyCategory: {},
      surveyDescription: {},
      businessLabels: {},
      surveyCategories: []
    };
  }

  componentDidMount() {
    this.fetchSurveyTemplateDetails();
    this.fetchSurveyCategories();
  }

  fetchSurveyCategories = () => {
    const dropdown = true;

    SurveyTemplateCategoryApi.getAll(dropdown).then(({ data }) => {
      const surveyCategories = data.map(({ id, name }) => ({ value: id, label: name }));
      this.setState({ surveyCategories });
    });
  }

  fetchSurveyTemplateDetails = () => {
    const { surveyTemplateId } = this.props.match.params;

    if (surveyTemplateId) {
      SurveyTemplateApi.getDetails(surveyTemplateId).then(({ data }) => {
        const { name, survey_template_category_id, description, categories } = data;
        let categoryIds = categories && categories.map(category => category.id);
        categoryIds = categoryIds ? categoryIds.join() : categoryIds;
        const surveyName = { value: name };
        const surveyCategory = { value: survey_template_category_id };
        const businessLabels = { value: categoryIds };
        const surveyDescription = { value: description };

        this.setState({
          surveyName, surveyCategory, businessLabels, surveyDescription
        });
      })
    }
  }

  handleSelectChange = (selectedValue, name) => {
    const value = selectedValue ? selectedValue : null;

    this.setState({
      [name]: {
        error: null,
        value
      }
    })
  };

  handleChange = (e) => {
    const { name, value, required } = e.target;
    let error = null;
    if (required)
      error = validate(name, value);
    this.setState({
      [name]: {
        ...this.state[name],
        error,
        value
      }
    });
  };

  handleBlur = (e) => {
    const { name, value, required } = e.target;
    let error = null;

    if (required)
      error = validate(name, value.trim());
    this.setState({
      [name]: {
        ...this.state[name],
        error,
        value: value.trim()
      }
    });
  }

  validateForm = () => {
    const { surveyName, surveyDescription, businessLabels, surveyCategory } = this.state;
    const { valid, _state } = formValidate({
      surveyName, surveyDescription, businessLabels, surveyCategory
    });
    this.setState({ ...this.state, ..._state });

    return valid;
  }

  handleCancel = (e) => {
    e.preventDefault();
    this.props.history.push(ROUTES.SURVEY_TEMPLATE_INDEX);
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { surveyTemplateId } = this.props.match.params;
    const {
      surveyName,
      surveyCategory,
      businessLabels,
      surveyDescription
    } = this.state;
    const category_ids = businessLabels.value ? businessLabels.value.split(',') : businessLabels.value;
    const formData = {
      name: surveyName.value,
      survey_template_category_id: surveyCategory.value,
      category_ids,
      description: surveyDescription.value,
    };

    if (this.validateForm()) {
      try {
        if (surveyTemplateId) {
          const { data } = await SurveyTemplateApi.update(surveyTemplateId, formData);
          if (data) {
            Toaster.getSuccessToaster('check-circle', `'${data.name}' updated successfully`);
            this.props.history.push(ROUTES.SURVEY_TEMPLATE_INDEX);
          }
        } else {
          const { data } = await SurveyTemplateApi.addNew(formData);
          if (data) {
            Toaster.getSuccessToaster('check-circle', `'${data.name}' added successfully'`);
            this.props.history.push(ROUTES.SURVEY_TEMPLATE_INDEX);
          }
        }
      } catch (e) {
        Toaster.getErrorToaster('exclamation-triangle', 'Oops! Something went wrong');
      }
    }
  }

  render() {
    const { surveyTemplateId } = this.props.match.params;
    const {
      surveyName,
      surveyCategories,
      surveyCategory,
      surveyDescription,
      businessLabels
    } = this.state;

    return (
      <div className="container">
        <SurveyTemplateForm
          editForm={surveyTemplateId}
          handleChange={this.handleChange}
          handleBlur={this.handleBlur}
          handleSubmit={this.handleSubmit}
          handleCancel={this.handleCancel}
          handleSelectChange={this.handleSelectChange}
          surveyName={surveyName}
          surveyCategories={surveyCategories}
          surveyCategory={surveyCategory}
          surveyDescription={surveyDescription}
          businessLabels={businessLabels}
        />
      </div>
    )
  }
}

AddSurveyTemplate.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
};

export default AddSurveyTemplate;



// WEBPACK FOOTER //
// ./src/components/categories/AddSurveyTemplate.js